"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridCount = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var adhere_ui_configprovider_1 = __importDefault(require("@baifendian/adhere-ui-configprovider"));
var Context_1 = require("./Context");
var Hooks_1 = require("./Hooks");
var Util_1 = require("./Util");
var selectorPrefix = 'adhere-ui-flex-layout-fixed';
exports.gridCount = 24;
/**
 * Fixed
 * @param {FixedProps} props
 * @param ref
 * @constructor
 */
var Fixed = (0, react_1.memo)((0, react_1.forwardRef)(function (props, ref) {
  var className = props.className,
    children = props.children,
    style = props.style,
    fit = props.fit,
    span = props.span,
    trigger = props.trigger,
    _a = props.collapseDirection,
    collapseDirection = _a === void 0 ? 'L' : _a,
    _b = props.collapsedSize,
    collapsedSize = _b === void 0 ? 80 : _b,
    _c = props.defaultCollapsible,
    defaultCollapsible = _c === void 0 ? false : _c,
    onCollapse = props.onCollapse,
    attrs = __rest(props, ["className", "children", "style", "fit", "span", "trigger", "collapseDirection", "collapsedSize", "defaultCollapsible", "onCollapse"]);
  var media = (0, react_1.useContext)(adhere_ui_configprovider_1.default.Context).media;
  var _d = (0, react_1.useContext)(Context_1.FlexContext),
    _e = _d.gutter,
    gutter = _e === void 0 ? 0 : _e,
    direction = _d.direction,
    contextChildren = _d.children;
  var elRef = (0, react_1.useRef)(null);
  var isUseGrid = (0, Hooks_1.useGrid)(props);
  var isUseGap = (0, Hooks_1.useGap)(gutter);
  var _f = (0, Hooks_1.useTrigger)({
      trigger: trigger,
      collapseDirection: collapseDirection,
      collapsedSize: collapsedSize,
      defaultCollapsible: defaultCollapsible,
      onCollapse: onCollapse,
      selectorPrefix: selectorPrefix,
      elRef: elRef
    }),
    renderTrigger = _f.renderTrigger,
    /*collapseClassName,*/collapseStyle = _f.collapseStyle;
  var classList = (0, react_1.useMemo)(function () {
    var _a;
    return (0, classnames_1.default)(selectorPrefix, className !== null && className !== void 0 ? className : '', (_a = {}, _a["".concat(selectorPrefix, "-fit")] = fit, _a["".concat(selectorPrefix, "-col-").concat(span)] = isUseGrid, _a["".concat(selectorPrefix, "-gap")] = isUseGap, _a));
  }, [className, span, fit, isUseGap, isUseGrid /*collapseClassName*/]);
  var styleList = (0, react_1.useMemo)(function () {
    var defaultStyle = style !== null && style !== void 0 ? style : {};
    var gridStyle = isUseGap ? (0, Util_1.getGridStyle)({
      gutter: gutter,
      span: span,
      children: contextChildren,
      direction: direction,
      media: media
    }) : {};
    return __assign(__assign(__assign({}, defaultStyle), gridStyle), collapseStyle !== null && collapseStyle !== void 0 ? collapseStyle : {});
  }, [style, gutter, collapseStyle, isUseGap, direction, media, span, contextChildren]);
  (0, react_1.useImperativeHandle)(ref, function () {
    return {
      getEl: function () {
        return elRef.current;
      }
    };
  });
  return react_1.default.createElement("div", __assign({
    ref: elRef
  }, attrs, {
    className: (0, classnames_1.default)(classList),
    style: styleList
  }), children, renderTrigger());
}));
Fixed.displayName = 'Fixed';
exports.default = Fixed;